import type { LearnerPath } from '@mio/shared';

/** A module's place on the learner's saved path. Labels only: nothing is locked. */
export type PathRole = 'start' | 'included' | 'optional';

export function pathRoleOf(
  path: LearnerPath | null | undefined,
  moduleNumber: number,
): PathRole | null {
  if (!path) return null;
  if (path.startModule === moduleNumber) return 'start';
  return path.modules.includes(moduleNumber) ? 'included' : 'optional';
}

const LABELS: Record<PathRole, string> = {
  start: 'Start here',
  included: 'On your path',
  optional: 'Optional',
};

export function pathLabel(role: PathRole | null): string | null {
  return role ? LABELS[role] : null;
}
